import React from "react";
import { Spinner } from "react-bootstrap";

const Loader = ({ ...rest }) => {
  return (
    <div className="text-center w-100 h-100 d-flex justify-content-center align-items-center">
      <Spinner animation="border" role="status" className="text-main" {...rest}>
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
};

export default Loader;
